/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding startup/initialization code.
 * Use "quasar new boot <name>" and add it there.
 * One boot file per concern. Then reference the file(s) in quasar.conf.js > boot:
 * boot: ['file', ...] // do not add ".js" extension to it.
 *
 * Boot files are your "main.js"
 **/

import Vue from 'vue';
import Quasar from 'quasar/src/vue-plugin.js';import QLayout from 'quasar/src/components/layout/QLayout.js';import QHeader from 'quasar/src/components/header/QHeader.js';import QDrawer from 'quasar/src/components/drawer/QDrawer.js';import QBar from 'quasar/src/components/bar/QBar.js';import QPageContainer from 'quasar/src/components/page/QPageContainer.js';import QPage from 'quasar/src/components/page/QPage.js';import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';import QToolbarTitle from 'quasar/src/components/toolbar/QToolbarTitle.js';import QBtn from 'quasar/src/components/btn/QBtn.js';import QField from 'quasar/src/components/field/QField.js';import QIcon from 'quasar/src/components/icon/QIcon.js';import QList from 'quasar/src/components/item/QList.js';import QItem from 'quasar/src/components/item/QItem.js';import QItemSection from 'quasar/src/components/item/QItemSection.js';import QItemLabel from 'quasar/src/components/item/QItemLabel.js';import QForm from 'quasar/src/components/form/QForm.js';import QInput from 'quasar/src/components/input/QInput.js';import QToggle from 'quasar/src/components/toggle/QToggle.js';import QMenu from 'quasar/src/components/menu/QMenu.js';import QSeparator from 'quasar/src/components/separator/QSeparator.js';import QCard from 'quasar/src/components/card/QCard.js';import QCardSection from 'quasar/src/components/card/QCardSection.js';import QCardActions from 'quasar/src/components/card/QCardActions.js';import QSelect from 'quasar/src/components/select/QSelect.js';import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';import QBadge from 'quasar/src/components/badge/QBadge.js';import QAvatar from 'quasar/src/components/avatar/QAvatar.js';import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';import QDialog from 'quasar/src/components/dialog/QDialog.js';import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';import QEditor from 'quasar/src/components/editor/QEditor.js';import QTimeline from 'quasar/src/components/timeline/QTimeline.js';import QTimelineEntry from 'quasar/src/components/timeline/QTimelineEntry.js';import QStepper from 'quasar/src/components/stepper/QStepper.js';import QStep from 'quasar/src/components/stepper/QStep.js';import QStepperNavigation from 'quasar/src/components/stepper/QStepperNavigation.js';import QRadio from 'quasar/src/components/radio/QRadio.js';import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';import QDate from 'quasar/src/components/date/QDate.js';import QTime from 'quasar/src/components/time/QTime.js';import QSpace from 'quasar/src/components/space/QSpace.js';import QTable from 'quasar/src/components/table/QTable.js';import QTab from 'quasar/src/components/tabs/QTab.js';import QTabs from 'quasar/src/components/tabs/QTabs.js';import QRouteTab from 'quasar/src/components/tabs/QRouteTab.js';import QTr from 'quasar/src/components/table/QTr.js';import QTh from 'quasar/src/components/table/QTh.js';import QTd from 'quasar/src/components/table/QTd.js';import QBanner from 'quasar/src/components/banner/QBanner.js';import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';import QNoSsr from 'quasar/src/components/no-ssr/QNoSsr.js';import Ripple from 'quasar/src/directives/Ripple.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';import Notify from 'quasar/src/plugins/Notify.js';import Loading from 'quasar/src/plugins/Loading.js';import Dialog from 'quasar/src/plugins/Dialog.js';import Meta from 'quasar/src/plugins/Meta.js';import Cookies from 'quasar/src/plugins/Cookies.js';;
Vue.use(Quasar, {
  config: {
    "brand": {
      "primary": "#383F51"
    }
  },
  components: {
    QLayout: QLayout,
    QHeader: QHeader,
    QDrawer: QDrawer,
    QBar: QBar,
    QPageContainer: QPageContainer,
    QPage: QPage,
    QToolbar: QToolbar,
    QToolbarTitle: QToolbarTitle,
    QBtn: QBtn,
    QField: QField,
    QIcon: QIcon,
    QList: QList,
    QItem: QItem,
    QItemSection: QItemSection,
    QItemLabel: QItemLabel,
    QForm: QForm,
    QInput: QInput,
    QToggle: QToggle,
    QMenu: QMenu,
    QSeparator: QSeparator,
    QCard: QCard,
    QCardSection: QCardSection,
    QCardActions: QCardActions,
    QSelect: QSelect,
    QTooltip: QTooltip,
    QBadge: QBadge,
    QAvatar: QAvatar,
    QCheckbox: QCheckbox,
    QDialog: QDialog,
    QScrollArea: QScrollArea,
    QEditor: QEditor,
    QTimeline: QTimeline,
    QTimelineEntry: QTimelineEntry,
    QStepper: QStepper,
    QStep: QStep,
    QStepperNavigation: QStepperNavigation,
    QRadio: QRadio,
    QPopupProxy: QPopupProxy,
    QDate: QDate,
    QTime: QTime,
    QSpace: QSpace,
    QTable: QTable,
    QTab: QTab,
    QTabs: QTabs,
    QRouteTab: QRouteTab,
    QTr: QTr,
    QTh: QTh,
    QTd: QTd,
    QBanner: QBanner,
    QExpansionItem: QExpansionItem,
    QNoSsr: QNoSsr
  },
  directives: {
    Ripple: Ripple,
    ClosePopup: ClosePopup
  },
  plugins: {
    Notify: Notify,
    Loading: Loading,
    Dialog: Dialog,
    Meta: Meta,
    Cookies: Cookies
  }
});